import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { IconCheck, IconArrow, IconHeart, IconLeaf } from "../components/Icons";
import { getCompliance } from "../lib/api";

export default function Compliance() {
  const [items, setItems] = useState([]);
  useEffect(() => { getCompliance().then(setItems).catch(() => {}); }, []);

  return (
    <div data-testid="compliance-page">
      <PageHeader
        eyebrow="Compliance consulting"
        title="Tailored plans for your role in the marketplace"
        lead="One standard of rigor across dedicated practices — built around proven methodologies and subject-matter depth."
        crumb="Compliance"
      />

      <section className="section bg-paper">
        <div className="wrap">
          <Reveal className="sec-head">
            <span className="eyebrow">Our practices</span>
            <h2>Compliance services</h2>
            <p>From sector-specific consulting to assessment, audit-readiness, and risk management.</p>
          </Reveal>
          <div className="hub-grid" data-testid="compliance-grid">
            {items.map((c, i) => (
              <Reveal key={c.id} delay={(i % 2) * 70}>
                <Link to={`/compliance/${c.slug}`} className="hub-card" data-testid={`compliance-card-${c.slug}`}>
                  <div className="hc-ic">
                    {c.practice === "healthcare" ? <IconHeart stroke="#e11d3c" /> : c.practice === "livestock" ? <IconLeaf stroke="#c9760c" /> : <IconCheck stroke="#e11d3c" />}
                  </div>
                  <h3>{c.title}</h3>
                  <p>{c.summary}</p>
                  <span className="more">Learn more <IconArrow /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
